import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
export const CareDiagram = () => {
    const { t } = useTranslation();
    return (_jsxs(Diagram, { "aria-label": t('home.hero.diagramLabel'), children: [_jsxs(DiagramHeading, { children: [_jsx("span", { children: "AI + Technology + Care" }), _jsx("span", { "aria-hidden": "true", children: "\u21B3" })] }), _jsxs(Drawing, { children: [_jsxs("svg", { width: "540", height: "430", viewBox: "0 0 540 430", fill: "none", "aria-hidden": "true", children: [_jsx("path", { d: "M18 112h352c72 0 122 46 122 114v68c0 57-35 99-92 99H150c-53 0-94-37-94-88v-17", stroke: "#A7E0DB", strokeWidth: "27" }), _jsx("path", { d: "M18 112h352c72 0 122 46 122 114v68c0 57-35 99-92 99H150c-53 0-94-37-94-88v-17", stroke: "#2A2F63", strokeWidth: "1.5" }), _jsx("path", { d: "M46 299l10-11 10 11", stroke: "#2A2F63", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("rect", { x: "117", y: "170", width: "294", height: "180", rx: "8", fill: "#2A2F63" }), _jsx("rect", { x: "128", y: "181", width: "272", height: "154", rx: "2", fill: "#FFFFFF" }), _jsx("path", { d: "M99 352h330l19 16H80l19-16Z", fill: "#F7F8F5", stroke: "#2A2F63", strokeWidth: "2", strokeLinejoin: "round" }), _jsx("path", { d: "M240 352h49l-5 5h-39l-5-5Z", fill: "#2A2F63" }), _jsx("path", { d: "M146 260h28c18 0 14-31 33-31 27 0 3 62 31 62 25 0-8-48 19-48 24 0 10 32 33 32 15 0 15-15 30-15h62", stroke: "#3E6D9C", strokeWidth: "3", strokeLinecap: "round" }), _jsx("path", { d: "m367 251 9 9-9 9", stroke: "#3E6D9C", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M270 20v37M262 20h16M262 57h16", stroke: "#D9E3E5", strokeWidth: "1.5" }), _jsx("path", { d: "M25 407h36M43 389v36M458 53h36M476 35v36", stroke: "#D9E3E5", strokeWidth: "1.5" }), _jsx("circle", { cx: "18", cy: "112", r: "5", fill: "#2A2F63" })] }), _jsxs(StartLabel, { children: [_jsx("span", { children: "01" }), t('home.hero.diagramStart')] }), _jsxs(EndLabel, { children: [_jsx("span", { children: "02" }), t('home.hero.diagramEnd')] })] }), _jsx("figcaption", { children: t('home.hero.diagramCaption') })] }));
};
const Diagram = styled.figure `
  width: 100%;
  max-width: 540px;
  margin: 0;
  color: ${({ theme }) => theme.colors.navy900};
  figcaption {
    margin-top: 1.1rem;
    font-size: 0.875rem;
    text-align: right;
    color: ${({ theme }) => theme.colors.muted};
  }
`;
const DiagramHeading = styled.div `
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.9rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  font-size: 0.75rem;
  letter-spacing: 0.09em;
  span:last-child {
    font-size: 1rem;
    line-height: 1;
  }
`;
const Drawing = styled.div `
  position: relative;
  padding-top: 1.5rem;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;
const StartLabel = styled.div `
  position: absolute;
  top: 8%;
  left: 3%;
  display: grid;
  gap: 0.15rem;
  max-width: 45%;
  font-size: clamp(0.8rem, 1.3vw, 1rem);
  line-height: 1.35;
  span {
    color: ${({ theme }) => theme.colors.muted};
    font-size: 0.7rem;
  }
`;
const EndLabel = styled(StartLabel) `
  top: 8%;
  left: 62%;
  max-width: 35%;
`;
